import React, { useEffect } from 'react';
import { useSettings } from '../../context/SettingsContext';
import './PrivacyPolicyPage.css';

const PrivacyPolicyPage = () => {
  const { t, language } = useSettings();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const content = {
    ru: (
      <div className="privacy-content">
          <section className="privacy-section">
            <h2>1. Общие положения</h2>
            <p>
              Настоящая Политика конфиденциальности (далее — «Политика») регулирует 
              порядок обработки и защиты персональных данных пользователей платформы 
              КыргызЭйд (далее — «Платформа»), принадлежащей Общественному фонду 
              "КыргызЭйд" (далее — «Фонд», «мы»).
            </p>
            <p>
              Используя Платформу, вы соглашаетесь с условиями настоящей Политики 
              и даете согласие на обработку ваших персональных данных.
            </p>
          </section>

          <section className="privacy-section">
            <h2>2. Определения</h2>
            <ul>
              <li><strong>Персональные данные</strong> — любая информация, относящаяся к прямо или косвенно определенному или определяемому физическому лицу (субъекту персональных данных).</li>
              <li><strong>Обработка персональных данных</strong> — любое действие или совокупность действий, совершаемых с персональными данными, включая сбор, запись, систематизацию, накопление, хранение, уточнение, извлечение, использование, передачу, обезличивание, блокирование, удаление, уничтожение.</li>
              <li><strong>Пользователь</strong> — лицо, имеющее доступ к Платформе посредством сети Интернет и использующее ее сервисы.</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>3. Какие данные мы собираем</h2>
            <p>При использовании Платформы мы можем собирать следующую информацию:</p>
            
            <h3>3.1. Информация при регистрации:</h3>
            <ul>
              <li>Адрес электронной почты</li>
              <li>Имя пользователя</li>
              <li>Пароль (хранится в зашифрованном виде)</li>
            </ul>

            <h3>3.2. Информация профиля (предоставляется добровольно):</h3>
            <ul>
              <li>Фотография профиля</li>
              <li>Дата рождения</li>
              <li>Номер телефона</li>
              <li>Биография</li>
            </ul>

            <h3>3.3. Данные об активности:</h3>
            <ul>
              <li>История просмотра новостей и книг</li>
              <li>Комментарии и отзывы</li>
              <li>Лайки и реакции</li>
              <li>Списки для чтения</li>
              <li>История скачиваний</li>
            </ul>

            <h3>3.4. Технические данные:</h3>
            <ul>
              <li>IP-адрес</li>
              <li>Тип браузера и устройства</li>
              <li>Операционная система</li>
              <li>Файлы cookie</li>
              <li>Данные о сеансах</li>
              <li>Логи действий</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>4. Цели обработки данных</h2>
            <p>Мы обрабатываем ваши персональные данные для следующих целей:</p>
            <ul>
              <li>Регистрация и авторизация на Платформе</li>
              <li>Предоставление доступа к функциям и сервисам</li>
              <li>Персонализация контента и рекомендаций</li>
              <li>Обработка запросов и обращений пользователей</li>
              <li>Улучшение качества сервиса</li>
              <li>Анализ статистики использования</li>
              <li>Обеспечение безопасности и предотвращение мошенничества</li>
              <li>Соблюдение законодательных требований</li>
              <li>Информирование о новостях и обновлениях (при согласии)</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>5. Правовые основания обработки</h2>
            <p>Обработка персональных данных осуществляется на основании:</p>
            <ul>
              <li>Вашего согласия</li>
              <li>Необходимости исполнения договора (Пользовательского соглашения)</li>
              <li>Законных интересов Фонда</li>
              <li>Требований законодательства Кыргызской Республики</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>6. Защита персональных данных</h2>
            <p>
              Мы применяем организационные и технические меры для защиты ваших 
              персональных данных от несанкционированного доступа, изменения, 
              раскрытия или уничтожения:
            </p>
            <ul>
              <li>Шифрование паролей и конфиденциальных данных</li>
              <li>Использование защищенного протокола HTTPS</li>
              <li>Регулярное резервное копирование данных</li>
              <li>Ограничение доступа к персональным данным</li>
              <li>Мониторинг и аудит безопасности</li>
              <li>Использование межсетевых экранов и систем обнаружения вторжений</li>
              <li>Регулярное обновление систем безопасности</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>7. Передача данных третьим лицам</h2>
            <p>
              Мы не продаем и не передаем ваши персональные данные третьим лицам, 
              за исключением следующих случаев:
            </p>
            <ul>
              <li>С вашего явного согласия</li>
              <li>Сервисам для обеспечения работы Платформы (хостинг, аналитика)</li>
              <li>По требованию законодательства или государственных органов</li>
              <li>Для защиты прав и интересов Фонда или других пользователей</li>
            </ul>
            <p>
              Все третьи лица, получающие доступ к данным, обязаны соблюдать их 
              конфиденциальность и использовать только в оговоренных целях.
            </p>
          </section>

          <section className="privacy-section">
            <h2>8. Файлы cookie</h2>
            <p>
              Платформа использует файлы cookie для улучшения пользовательского опыта. 
              Cookie — это небольшие текстовые файлы, хранящиеся на вашем устройстве.
            </p>
            <h3>Мы используем следующие типы cookie:</h3>
            <ul>
              <li><strong>Обязательные</strong> — необходимы для работы сайта</li>
              <li><strong>Функциональные</strong> — запоминают ваши предпочтения</li>
              <li><strong>Аналитические</strong> — собирают статистику посещений</li>
            </ul>
            <p>
              Вы можете управлять cookie через настройки браузера. Отключение cookie 
              может ограничить функциональность Платформы.
            </p>
          </section>

          <section className="privacy-section">
            <h2>9. Ваши права</h2>
            <p>Вы имеете следующие права в отношении ваших персональных данных:</p>
            <ul>
              <li><strong>Право на доступ</strong> — получить информацию о том, какие данные мы обрабатываем</li>
              <li><strong>Право на исправление</strong> — исправить неточные или неполные данные</li>
              <li><strong>Право на удаление</strong> — запросить удаление ваших данных ("право на забвение")</li>
              <li><strong>Право на ограничение обработки</strong> — ограничить обработку в определенных случаях</li>
              <li><strong>Право на перенос данных</strong> — получить ваши данные в структурированном формате</li>
              <li><strong>Право на отзыв согласия</strong> — в любой момент отозвать согласие на обработку</li>
              <li><strong>Право на возражение</strong> — возразить против обработки данных</li>
            </ul>
            <p>
              Для реализации ваших прав направьте запрос на адрес: <a href="mailto:privacy@kyrgyzaid.kg">privacy@kyrgyzaid.kg</a>
            </p>
          </section>

          <section className="privacy-section">
            <h2>10. Срок хранения данных</h2>
            <ul>
              <li>Данные учетной записи — до удаления аккаунта</li>
              <li>История активности — 3 года с момента последней активности</li>
              <li>Логи и технические данные — 1 год</li>
              <li>Обращения в поддержку — 5 лет</li>
            </ul>
            <p>
              После истечения сроков хранения данные удаляются безвозвратно или 
              обезличиваются для статистических целей.
            </p>
          </section>

          <section className="privacy-section">
            <h2>11. Дети</h2>
            <p>
              Платформа не предназначена для детей младше 14 лет. Мы осознанно 
              не собираем персональные данные от детей. Если вы являетесь родителем 
              и обнаружили, что ваш ребенок предоставил нам свои данные, свяжитесь 
              с нами для их удаления.
            </p>
          </section>

          <section className="privacy-section">
            <h2>12. Международная передача данных</h2>
            <p>
              Ваши данные хранятся и обрабатываются на территории Кыргызской Республики. 
              В случае передачи данных в другие страны мы обеспечиваем адекватный уровень 
              защиты в соответствии с международными стандартами.
            </p>
          </section>

          <section className="privacy-section">
            <h2>13. Изменения в Политике</h2>
            <p>
              Мы оставляем за собой право вносить изменения в настоящую Политику. 
              Обновленная версия публикуется на данной странице с указанием даты 
              последнего обновления. Существенные изменения будут направлены на ваш 
              email.
            </p>
            <p>
              Продолжение использования Платформы после внесения изменений означает 
              ваше согласие с новой редакцией Политики.
            </p>
          </section>

          <section className="privacy-section">
            <h2>14. Контактная информация</h2>
            <p>
              По вопросам, связанным с обработкой персональных данных и настоящей 
              Политикой, вы можете обратиться к нам:
            </p>
            <div className="contact-info">
              <p><strong>Общественный фонд "КыргызЭйд"</strong></p>
              <p>📧 Email: <a href="mailto:privacy@kyrgyzaid.kg">privacy@kyrgyzaid.kg</a></p>
              <p>📧 Общие вопросы: <a href="mailto:info@kyrgyzaid.kg">info@kyrgyzaid.kg</a></p>
              <p>📞 Телефон: +996 (xxx) xx-xx-xx</p>
              <p>📍 Адрес: г. Бишкек, Кыргызская Республика</p>
              <p>🕐 Время работы: Пн-Пт, 9:00-18:00</p>
            </div>
          </section>

          <section className="privacy-section agreement">
            <h2>15. Согласие</h2>
            <p>
              Используя Платформу КыргызЭйд, вы подтверждаете, что:
            </p>
            <ul>
              <li>Ознакомлены с настоящей Политикой конфиденциальности</li>
              <li>Понимаете цели и способы обработки ваших персональных данных</li>
              <li>Даете согласие на обработку ваших персональных данных в соответствии с настоящей Политикой</li>
              <li>Вам исполнилось 14 лет, либо вы получили согласие родителей/опекунов</li>
            </ul>
          </section>
      </div>
    ),
    ky: (
      <div className="privacy-content">
          <section className="privacy-section">
            <h2>1. Жалпы жоболор</h2>
            <p>
              Бул Купуялык саясаты (мындан ары — "Саясат") 
              "КыргызЭйд" Коомдук фондуна (мындан ары — "Фонд", "биз") таандык 
              КыргызЭйд платформасынын (мындан ары — "Платформа") колдонуучуларынын жеке маалыматтарын иштетүү жана коргоо тартибин жөнгө салат.
            </p>
            <p>
              Платформаны колдонуу менен, сиз ушул Саясаттын шарттарына макулдугуңузду билдиресиз 
              жана жеке маалыматтарыңызды иштетүүгө макулдук бересиз.
            </p>
          </section>

          <section className="privacy-section">
            <h2>2. Аныктамалар</h2>
            <ul>
              <li><strong>Жеке маалыматтар</strong> — түздөн-түз же кыйыр түрдө аныкталган же аныкталуучу жеке жакты (жеке маалыматтардын субъектиси) мүнөздөгөн ар кандай маалымат.</li>
              <li><strong>Жеке маалыматтарды иштетүү</strong> — жеке маалыматтар менен жасалган ар кандай аракет же аракеттердин жыйындысы, анын ичинде чогултуу, жазуу, системалаштыруу, топтоо, сактоо, тактоо, алуу, пайдалануу, берүү, ээсиздендирүү, бөгөттөө, өчүрүү, жок кылуу.</li>
              <li><strong>Колдонуучу</strong> — Интернет тармагы аркылуу Платформага кирүү мүмкүнчүлүгү бар жана анын кызматтарын пайдаланган жак.</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>3. Биз кандай маалыматтарды топтойбуз</h2>
            <p>Платформаны колдонууда биз төмөнкү маалыматтарды чогултушубуз мүмкүн:</p>
            
            <h3>3.1. Каттоо маалыматы:</h3>
            <ul>
              <li>Электрондук почта дареги</li>
              <li>Колдонуучунун аты (логин)</li>
              <li>Сырсөз (шифрленген түрдө сакталат)</li>
            </ul>

            <h3>3.2. Профиль маалыматы (ыктыярдуу түрдө берилет):</h3>
            <ul>
              <li>Профиль сүрөтү</li>
              <li>Туулган күнү</li>
              <li>Телефон номери</li>
              <li>Өмүр баяны</li>
            </ul>

            <h3>3.3. Активдүүлүк жөнүндө маалыматтар:</h3>
            <ul>
              <li>Жаңылыктарды жана китептерди көрүү тарыхы</li>
              <li>Комментарийлер жана сын-пикирлер</li>
              <li>Лайктар жана реакциялар</li>
              <li>Окуу тизмелери</li>
              <li>Жүктөө тарыхы</li>
            </ul>

            <h3>3.4. Техникалык маалыматтар:</h3>
            <ul>
              <li>IP-дареги</li>
              <li>Браузердин жана түзмөктүн түрү</li>
              <li>Операциялык система</li>
              <li>Cookie файлдары</li>
              <li>Сеанстар жөнүндө маалымат</li>
              <li>Аракеттердин логдору</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>4. Маалыматтарды иштетүүнүн максаттары</h2>
            <p>Биз сиздин жеке маалыматтарыңызды төмөнкү максаттарда иштетебиз:</p>
            <ul>
              <li>Платформада каттоо жана авторизациялоо</li>
              <li>Функцияларга жана кызматтарга жетүү мүмкүнчүлүгүн берүү</li>
              <li>Контентти жана сунуштарды жекелештирүү</li>
              <li>Колдонуучулардын суроо-талаптарын жана кайрылууларын иштеп чыгуу</li>
              <li>Кызматтын сапатын жакшыртуу</li>
              <li>Колдонуу статистикасын талдоо</li>
              <li>Коопсуздукту камсыз кылуу жана алдамчылыктын алдын алуу</li>
              <li>Мыйзам талаптарын сактоо</li>
              <li>Жаңылыктар жана жаңыртуулар жөнүндө маалымдоо (макулдук болгондо)</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>5. Иштетүүнүн укуктук негиздери</h2>
            <p>Жеке маалыматтарды иштетүү төмөнкүлөрдүн негизинде жүргүзүлөт:</p>
            <ul>
              <li>Сиздин макулдугуңуз</li>
              <li>Келишимди (Колдонуучу келишимин) аткаруу зарылчылыгы</li>
              <li>Фонддун мыйзамдуу кызыкчылыктары</li>
              <li>Кыргыз Республикасынын мыйзамдарынын талаптары</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>6. Жеке маалыматтарды коргоо</h2>
            <p>
              Биз сиздин жеке маалыматтарыңызды уруксатсыз кирүүдөн, өзгөртүүдөн, 
              ачуудан же жок кылуудан коргоо үчүн уюштуруучулук жана техникалык чараларды көрөбүз:
            </p>
            <ul>
              <li>Сырсөздөрдү жана купуя маалыматтарды шифрлөө</li>
              <li>Коопсуз HTTPS протоколун колдонуу</li>
              <li>Маалыматтардын резервдик көчүрмөсүн үзгүлтүксүз жасоо</li>
              <li>Жеке маалыматтарга кирүү мүмкүнчүлүгүн чектөө</li>
              <li>Коопсуздукту мониторингдөө жана аудит</li>
              <li>Тармактар аралык экрандарды жана кол салууларды аныктоо системаларын колдонуу</li>
              <li>Коопсуздук системаларын үзгүлтүксүз жаңыртуу</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>7. Маалыматтарды үчүнчү жактарга берүү</h2>
            <p>
              Биз сиздин жеке маалыматтарыңызды сатпайбыз жана үчүнчү жактарга бербейбиз, 
              төмөнкү учурлардан тышкары:
            </p>
            <ul>
              <li>Сиздин так макулдугуңуз менен</li>
              <li>Платформанын иштешин камсыз кылган кызматтарга (хостинг, аналитика)</li>
              <li>Мыйзамдардын же мамлекеттик органдардын талабы боюнча</li>
              <li>Фонддун же башка колдонуучулардын укуктарын жана кызыкчылыктарын коргоо үчүн</li>
            </ul>
            <p>
              Маалыматтарга кирүү мүмкүнчүлүгүн алган бардык үчүнчү жактар алардын 
              купуялуулугун сактоого жана макулдашылган максаттарда гана колдонууга милдеттүү.
            </p>
          </section>

          <section className="privacy-section">
            <h2>8. Cookie файлдары</h2>
            <p>
              Платформа колдонуучу тажрыйбасын жакшыртуу үчүн cookie файлдарын колдонот. 
              Cookie — бул сиздин түзмөгүңүздө сакталган кичинекей тексттик файлдар.
            </p>
            <h3>Биз cookie файлдарынын төмөнкү түрлөрүн колдонобуз:</h3>
            <ul>
              <li><strong>Милдеттүү</strong> — сайттын иштеши үчүн зарыл</li>
              <li><strong>Функционалдык</strong> — сиздин артыкчылыктарыңызды эстейт</li>
              <li><strong>Аналитикалык</strong> — кирүүлөрдүн статистикасын топтойт</li>
            </ul>
            <p>
              Сиз браузердин жөндөөлөрү аркылуу cookie файлдарын башкара аласыз. Cookie файлдарын өчүрүү 
              Платформанын иштешин чектеп коюшу мүмкүн.
            </p>
          </section>

          <section className="privacy-section">
            <h2>9. Сиздин укуктарыңыз</h2>
            <p>Сиз жеке маалыматтарыңызга карата төмөнкү укуктарга ээсиз:</p>
            <ul>
              <li><strong>Кирүү укугу</strong> — биз кандай маалыматтарды иштетип жатканыбыз жөнүндө маалымат алуу</li>
              <li><strong>Оңдоо укугу</strong> — так эмес же толук эмес маалыматтарды оңдоо</li>
              <li><strong>Өчүрүү укугу</strong> — маалыматтарыңызды өчүрүүнү сурануу ("унутулуу укугу")</li>
              <li><strong>Иштетүүнү чектөө укугу</strong> — белгилүү бир учурларда иштетүүнү чектөө</li>
              <li><strong>Маалыматтарды көчүрүү укугу</strong> — маалыматтарыңызды структураланган форматта алуу</li>
              <li><strong>Макулдукту кайтарып алуу укугу</strong> — каалаган убакта иштетүүгө берилген макулдукту кайтарып алуу</li>
              <li><strong>Каршы чыгуу укугу</strong> — маалыматтарды иштетүүгө каршы чыгуу</li>
            </ul>
            <p>
              Укуктарыңызды ишке ашыруу үчүн суроо-талапты төмөнкү дарекке жөнөтүңүز: <a href="mailto:privacy@kyrgyzaid.kg">privacy@kyrgyzaid.kg</a>
            </p>
          </section>

          <section className="privacy-section">
            <h2>10. Маалыматтарды сактоо мөөнөтү</h2>
            <ul>
              <li>Аккаунт маалыматтары — аккаунт өчүрүлгөнгө чейин</li>
              <li>Активдүүлүк тарыхы — акыркы активдүүлүктөн баштап 3 жыл</li>
              <li>Логдор жана техникалык маалыматтар — 1 жыл</li>
              <li>Колдоо кызматына кайрылуулар — 5 жыл</li>
            </ul>
            <p>
              Сактоо мөөнөтү аяктагандан кийин маалыматтар кайтарымсыз жок кылынат же 
              статистикалык максаттар үчүн ээсиздендирилет.
            </p>
          </section>

          <section className="privacy-section">
            <h2>11. Балдар</h2>
            <p>
              Платформа 14 жашка чейинки балдарга арналган эмес. Биз аң-сезимдүү түрдө 
              балдардан жеке маалыматтарды чогултпайбыз. Эгерде сиз ата-эне болсоңуз 
              жана балаңыз бизге өз маалыматтарын бергенин байкасаңыз, 
              аларды өчүрүү үчүн биз менен байланышыңыз.
            </p>
          </section>

          <section className="privacy-section">
            <h2>12. Маалыматтарды эл аралык деңгээлде берүү</h2>
            <p>
              Сиздин маалыматтар Кыргыз Республикасынын аймагында сакталат жана иштетилет. 
              Маалыматтарды башка өлкөлөргө берген учурда, биз эл аралык стандарттарга ылайык 
              коргоонун тиешелүү деңгээлин камсыз кылабыз.
            </p>
          </section>

          <section className="privacy-section">
            <h2>13. Саясатка өзгөртүүлөрдү киргизүү</h2>
            <p>
              Биз бул Саясатка өзгөртүүлөрдү киргизүү укугун өзүбүздө калтырабыз. 
              Жаңыртылган версия акыркы жаңылоо күнүн көрсөтүү менен ушул баракчада жарыяланат. 
              Олуттуу өзгөрүүлөр тууралуу email аркылуу кабарланат.
            </p>
            <p>
              Өзгөртүүлөр киргизилгенден кийин Платформаны колдонууну улантуу — 
              Саясаттын жаңы редакциясына макулдугуңузду билдирет.
            </p>
          </section>

          <section className="privacy-section">
            <h2>14. Байланыш маалыматы</h2>
            <p>
              Жеке маалыматтарды иштетүү жана ушул Саясат боюнча суроолор менен 
              бизге кайрылсаңыз болот:
            </p>
            <div className="contact-info">
              <p><strong>"КыргызЭйд" Коомдук фонду</strong></p>
              <p>📧 Email: <a href="mailto:privacy@kyrgyzaid.kg">privacy@kyrgyzaid.kg</a></p>
              <p>📧 Жалпы суроолор: <a href="mailto:info@kyrgyzaid.kg">info@kyrgyzaid.kg</a></p>
              <p>📞 Телефон: +996 (xxx) xx-xx-xx</p>
              <p>📍 Дарек: Бишкек ш., Кыргыз Республикасы</p>
              <p>🕐 Иштөө убактысы: Дш-Жм, 9:00-18:00</p>
            </div>
          </section>

          <section className="privacy-section agreement">
            <h2>15. Макулдук</h2>
            <p>
              КыргызЭйд Платформасын колдонуу менен, сиз төмөнкүлөрдү ырастайсыз:
            </p>
            <ul>
              <li>Бул Купуялык саясаты менен тааныштыңыз</li>
              <li>Сиздин жеке маалыматтарыңызды иштетүү максаттарын жана жолдорун түшүнөсүз</li>
              <li>Жеке маалыматтарыңызды ушул Саясатка ылайык иштетүүгө макулдук бересиз</li>
              <li>Сиз 14 жашка толдуңуз же ата-энелердин/камкорчулардын макулдугун алдыңыз</li>
            </ul>
          </section>
      </div>
    )
  };

  return (
    <div className="privacy-page">
      <div className="privacy-container">
        <div className="privacy-header">
          <h1 className="privacy-title">{t('privacyPolicy')}</h1>
          <p className="privacy-updated">
            {language === 'ru' 
              ? `Последнее обновление: ${new Date().toLocaleDateString('ru-RU', { year: 'numeric', month: 'long', day: 'numeric' })}`
              : `Акыркы жаңылоо: ${new Date().toLocaleDateString('ky-KG', { year: 'numeric', month: 'long', day: 'numeric' })}`
            }
          </p>
        </div>
        
        {content[language] || content.ru}

        <div className="privacy-footer">
          <p>
            {language === 'ru' 
              ? 'Если у вас есть вопросы или предложения по улучшению нашей Политики конфиденциальности, пожалуйста, свяжитесь с нами.'
              : 'Эгерде сизде Купуялык саясатыбызды жакшыртуу боюнча суроолор же сунуштар болсо, биз менен байланышыңыз.'
            }
          </p>
          <p className="version-info">
            {language === 'ru' 
              ? 'Версия: 1.0 | Дата вступления в силу: 1 января 2024 г.'
              : 'Версия: 1.0 | Күчүнө кирген күнү: 1-январь 2024-ж.'
            }
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
